/** @jsxImportSource @emotion/react */

import EmptyImg from "assets/desktop/images/emptyData.png";
import MDrawer from "components/mobile/MDrawer";
import MGameFavouriteCard from "components/mobile/MGameFavouriteCard";
import { userPath } from "constants/path";
import _map from "lodash/map";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectDataSubGameFavourite } from "store/game";

import { MFavouriteGamePageStyle } from "./index.style";

const MFavouriteGamePage = () => {
  const navigate = useNavigate();
  const listGameFavourite = useSelector(selectDataSubGameFavourite);
  const [isOpenDraw, setIsOpenDraw] = useState<boolean>(true);

  const handleCloseDraw = () => {
    setIsOpenDraw(false);
    navigate(userPath);
  };

  const renderList = () => {
    if (!listGameFavourite?.length) {
      return (
        <div css={MFavouriteGamePageStyle.bodyEmpty}>
          <img alt="" src={EmptyImg} />
          <h3>Không có dữ liệu nào được lưu </h3>
          <span>Mau chóng đi đăng ký trò chơi yêu thích của bạn nào !</span>
        </div>
      );
    }

    return (
      <div css={MFavouriteGamePageStyle.listGame}>
        {_map(listGameFavourite, (item, index) => (
          <MGameFavouriteCard {...item} key={index} />
        ))}
      </div>
    );
  };

  return (
    <div css={MFavouriteGamePageStyle.self}>
      <MDrawer title="Yêu thích" isOpen={isOpenDraw} onClose={handleCloseDraw}>
        {renderList()}
      </MDrawer>
    </div>
  );
};

export default MFavouriteGamePage;
